const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/public/brand`;

export const LOGO_COLOR = `${BASE}/logo-color.png`;
export const LOGO_WHITE = `${BASE}/logo-white.png`;
export const FAVICON = `${BASE}/favicon.png`;

// onDark: white logo for dark backgrounds / photos; otherwise the color logo for light backgrounds.
export function Logo({ onDark = false, className = "h-9 w-auto", testid = "brand-logo", version }) {
  const src = (onDark ? LOGO_WHITE : LOGO_COLOR) + (version ? `?v=${version}` : "");
  return <img src={src} alt="GESTA CV" className={`object-contain ${className}`} data-testid={testid}
    style={onDark ? { filter: "drop-shadow(0 1px 3px rgba(0,0,0,.35))" } : undefined} />;
}
